import React, { useEffect, useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import { MyPageHead } from 'components/pages/myPage/common';
import theme from 'styles/theme';
import { useState } from 'react';
import MarketInfoTabView from 'components/pages/market/detail/MarketInfoTabView';
import MarketSuggestions from 'components/pages/market/detail/MarketSuggestions';
import MarketSalesInfo from 'components/pages/market/detail/MarketSalesInfo';
import { useNavigate, useParams } from 'react-router-dom';
import useMarket from 'hooks/useMarket';
import { resetMarketDetail } from 'redux/modules/market';
import MarketDetailTopInfo from 'components/pages/market/detail/MarketDetailTopInfo';
import MarketDetailTabBar from 'components/pages/market/detail/MarketDetailTabBar';
import useUser from 'hooks/useUser';

function MarketDetail() {
   // states
   const [tabIndex, setTabIndex] = useState(0);
   const [marketDetailInfo, setMarketDetailInfo] = useState(null);
   const pageRef = useRef(null);
   const tabViewRef = useRef(null);

   // handlers
   const handleTabIndex = index => {
      setTabIndex(index);
      if (!tabViewRef) return;
      tabViewRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
   };

   // hooks
   const { marketDetail, fetchMarketDetail } = useMarket();
   const { getUserInfo } = useUser();
   const params = useParams();
   useEffect(() => {
      getUserInfo();
   }, []);
   useEffect(() => {
      if (!params?.marketId) return;
      const marketId = Number(params.marketId);
      resetMarketDetail();
      setMarketDetailInfo(null);
      fetchMarketDetail({ wholeId: marketId });
   }, [params]);
   useLayoutEffect(() => {
      if (!marketDetail) return;
      setMarketDetailInfo(marketDetail);
   }, [marketDetail]);

   if (!marketDetailInfo) {
      return <></>;
   }
   return (
      <MarketDetailWrap>
         <TitleBar title={marketDetailInfo.whole_name} />
         <MarketBody id="market-body" ref={pageRef}>
            <MarketDetailTopInfo info={marketDetailInfo} />
            <MarketDetailTabBar tabIndex={tabIndex} handleTabIndex={handleTabIndex} />
            <MarketTabView ref={tabViewRef}>
               {tabIndex === 0 ? (
                  <>
                     <MarketSalesInfo />
                     <MarketInfoTabView info={marketDetailInfo} />
                  </>
               ) : (
                  <MarketInfoTabView info={marketDetailInfo} />
               )}
            </MarketTabView>
            <MarketSuggestions info={marketDetailInfo} parentRef={pageRef} />
         </MarketBody>
      </MarketDetailWrap>
   );
}

export default MarketDetail;

const MarketDetailWrap = styled.div`
   height: 100%;
`;

const TitleBar = styled(MyPageHead)`
   position: sticky;
   background-color: ${theme.color.white};
   top: 0;
`;

const MarketBody = styled.div`
   background-color: ${theme.color.gray50};
   height: 100%;
   overflow-y: scroll;
   -ms-overflow-style: none;
   scrollbar-width: none;
   &::-webkit-scrollbar {
      display: none;
   }
`;

const MarketTabView = styled.section`
   scroll-margin-top: 45px;
`;
